import React from "react"

import type { BadgeProps } from "@chakra-ui/react"
import { Badge } from "@chakra-ui/react"

import { toSentenceCase } from "@supliful/domain"

const statusColors = {
  NEW: "yellowBright",
  PROCESSING: "yellowBright",
  ACCEPTED: "primary",
  IN_PROGRESS: "primary",
  COMPLETED: "primary",
  CANCELED: "red",
  RETURNED: "yellowBright",
} as const

type OrderStatus = keyof typeof statusColors

type StatusBadgeProps = BadgeProps & {
  status: OrderStatus | string
}

export const StatusBadge = ({ status, ...rest }: StatusBadgeProps) => {
  // Type guard to check if status is valid
  const color =
    status in statusColors ? statusColors[status as OrderStatus] : "gray" // Fallback color for unknown statuses

  return (
    <Badge colorScheme={color} {...rest}>
      {toSentenceCase(status)}
    </Badge>
  )
}
